import { render, staticRenderFns } from "./CloseCircleFilled.vue?vue&type=template&id=2b2dc82e"
import script from "./CloseCircleFilled.vue?vue&type=script&lang=js"
export * from "./CloseCircleFilled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports